import React, { useState, useEffect } from 'react';
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";

import { Helmet } from "react-helmet";
import { BalicekContent, fetchBalicek } from '../../lib/cms.ts';

import { FaAngleRight } from "react-icons/fa6";

import 'animate.css';


import '../../styles/desktop/balicky/1920x1080.css';
import '../../styles/desktop/balicky/1366x768px.css';
import '../../styles/desktop/balicky/2560x1440px.css';
import '../../styles/mobile/balicky/360x640px.css';

function Balicky() {
  const [balicek, setBalicek] = useState<BalicekContent | null>(null);

  useEffect(() => {
    fetchBalicek().then((data) => setBalicek(data)).catch(console.error);
  }, []);

  if (!balicek) return null;

  return (
    <div>

<Helmet>
  <title>Ubytovací balíčky | Hospůdka pod Rablinů</title>
  <meta
    name="description"
    content="Prohlédněte si naše výhodné ubytovací balíčky – víkendové pobyty, romantické večery nebo relaxační dny v přírodě Beskyd."
  />
  <meta name="robots" content="index, follow" />
  <meta name="keywords" content="ubytování, balíčky, víkendový pobyt, penzion Beskydy, romantické ubytování, relax, Zlín, příroda" />
  <meta name="author" content="GAMPERIOS s.r.o." />

  {/* Open Graph */}
  <meta property="og:title" content="Ubytovací balíčky | Hospůdka pod Rablinů" />
  <meta
    property="og:description"
    content="Objevte výhodné ubytovací balíčky v našem penzionu. Odpočinek, výlety, jídlo i atmosféra na jednom místě."
  />
  <meta
    property="og:image"
    content="https://www.hospudkapodrablinu.cz/img/hospudka-pod-rablinu-main-foto-1.jpg"
  />
  <meta property="og:url" content="https://www.hospudkapodrablinu.cz/balicky" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Hospůdka pod Rablinů" />
  <meta property="og:locale" content="cs_CZ" />

  {/* Twitter meta */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Ubytovací balíčky | Hospůdka pod Rablinů" />
  <meta
    name="twitter:description"
    content="Víkendový relax, romantický pobyt nebo oslava v přírodě? Vyberte si z našich ubytovacích balíčků."
  />
  <meta
    name="twitter:image"
    content="https://www.hospudkapodrablinu.cz/img/hospudka-pod-rablinu-main-foto-1.jpg"
  />
</Helmet>


      {/* MOBILE */}
      <div className='mobile-vypnuti'>
        <div id="menu-mobile-main">
          <Navbar />
        </div>


        <h1 className='mobile-balicky-nazev-balicku-main'>{balicek.nadpis}</h1>
        <h4 className='mobile-balicky-nazev-balicku-second'>{balicek.podnadpis}</h4>
        <img src={balicek.obrazekMobilniUrl ?? undefined} alt={`Balíček ${balicek.nadpis}`} className='mobile-balicky-obrazek-pod-second' />
        <h3 className='mobile-balicky-nazev-balicku-third'>{balicek.uvodniText}</h3>

        <h1 className='mobile-balicky-nazev-balicku-obsah-pobytoveho-balicku'>OBSAH POBYTOVÉHO BALÍČKU</h1>
        {balicek.obsahBalicku?.map((polozka, index) => (
          <h1 key={index} className='mobile-balicky-nazev-balicku-obsah-pobytoveho-balicku3'>{polozka}</h1>
        ))}

        <h1 className='mobile-balicky-nazev-balicku-obsah-pobytoveho-balicku-main'>CENOVÁ NABÍDKA</h1>
        <div className="mobile-balicky-table">
          {balicek.cenik?.map((radek, index) => (
            <div className="mobile-balicky-row" key={index}>
              <div className="mobile-balicky-label">{radek.popis}</div>
              <div className="mobile-balicky-price"><u>2 noci: </u>{radek.noci2}</div>
              <div className="mobile-balicky-price"><u>3 noci: </u>{radek.noci3}</div>
              <div className="mobile-balicky-price"><u>4 noci: </u>{radek.noci4}</div>
              <br /><br />
            </div>
          ))}
        </div>

        <h1 className='mobile-balicky-nazev-balicku-prijde-sem'>{balicek.dodatek}</h1>
        <div className='mobile-pozadi-bacliky'></div>

        {/* Kontaktni informace */}
        <Footer />


      </div>

      {/* DESKTOP */}
      <div className='desktop-vypnuti'>


        <div className='desktop-navbar'>
          <Navbar />
        </div>

        <div className='desktop-balicky-body'>
          <h3 className='desktop-balicky-text-1'>BALÍČKY</h3>
        </div>

        <img src={balicek.obrazekDesktop1Url ?? undefined} alt={`Balíček ${balicek.nadpis}`} className='desktop-balicky-fotka-main-1' />
        <h1 className='desktop-balicky-1-text-main'>{balicek.nadpis}</h1>
        <h4 className='desktop-balicky-text-second-1'>{balicek.podnadpis}</h4>
        <h4 className='desktop-balicky-text-second-2'>{balicek.uvodniText}</h4>

        <h1 className='desktop-balicky-obsah-balicku'>Obsah pobytového balíčku:</h1>
        <h4 className='desktop-balicky-obsah-balicku-2'>
          {balicek.obsahBalicku?.map((p, i) => (<div key={i}><FaAngleRight /> {p}<br /></div>))}
        </h4>

        <img src={balicek.obrazekDesktop2Url ?? undefined} alt={`Balíček ${balicek.nadpis}`} className='desktop-balicky-fotka-main-2' />
        <img src='./img/hlavni-interier.jpg' alt='Interiér Hospůdky pod Rablinů' className='desktop-balicky-fotka-main-3' />

        <h1 className='desktop-balicky-cena-balicku'>Cenová nabídka:</h1>
        <table className='desktop-balicky-ceny-tabulka'>
          <thead>
            <tr>
              <th>Počet osob</th><th></th><th></th><th>4 noci</th><th>3 noci</th><th>2 noci</th>
            </tr>
          </thead>
          <tbody>
            {balicek.cenik?.map((r, i) => (
              <tr key={i}>
                <td>{r.popis}</td><td></td><td></td><td>{r.noci4}</td><td>{r.noci3}</td><td>{r.noci2}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <p className='desktop-balicky-text-pod-tabulku'>{balicek.dodatek}</p>
        <div className='desktop-balicky-footer'><Footer /></div>
      </div>
    </div>
  );
}

export default Balicky;
